import {Component, ElementRef} from '@angular/core';

@Component({
  selector: 'app-element-loader',
  imports: [],
  templateUrl: './element-loader.component.html',
  styleUrl: './element-loader.component.scss'
})
export class ElementLoaderComponent {
  constructor(private elementRef: ElementRef) {
  }

  setPosition(left: number, top: number): void {
    this.elementRef.nativeElement.style.left = left + 'px';
    this.elementRef.nativeElement.style.top = top + 'px';
  }

  setSize(width: number, height: number): void {
    this.elementRef.nativeElement.style.width = width + 'px';
    this.elementRef.nativeElement.style.height = height + 'px';
  }
}
